import { render, staticRenderFns } from "./DonutChart45.vue?vue&type=template&id=bb1834c0&scoped=true&"
import script from "./DonutChart45.vue?vue&type=script&lang=js&"
export * from "./DonutChart45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1834c0",
  null
  
)

export default component.exports